module.exports = __webpack_public_path__ + "static/img/3.0ff04e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/zh/3.png
// module id = AMbF
// module chunks = 0